import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-DHAl7Frv.js';
import { a as addPrevNextButtonClickHandlers } from './arrow-buttons-CY1f9syu.js';
import { o as observeCarouselVisibility } from './visibility-1aJUVV5h.js';

class TilesCardSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  /** @type {ReturnType<typeof observeCarouselVisibility> | null} */
  #visibility = null;

  connectedCallback() {
    const viewport = this.querySelector('.embla__viewport');
    if (!viewport) return;

    this.#visibility = observeCarouselVisibility(this, {
      onEnter: () => {
        this.#embla = EmblaCarousel(viewport, {
          align: 'start',
          containScroll: 'trim',
          direction: document.dir || 'ltr',
        });

        const scrollbar = this.querySelector('.embla__scrollbar');
        if (scrollbar) addScrollBarListener(this.#embla, scrollbar);

        const prevBtn = this.querySelector('.embla-button--prev');
        const nextBtn = this.querySelector('.embla-button--next');
        if (prevBtn && nextBtn) addPrevNextButtonClickHandlers(this.#embla, prevBtn, nextBtn);
      },
      getEmbla: () => this.#embla,
    });
  }

  disconnectedCallback() {
    this.#visibility?.disconnect();
    this.#embla?.destroy();
    this.#embla = undefined;
  }
}

customElements.define('tiles-card-slider', TilesCardSlider);
